export const DEFAULT_BACKGROUND_IMG = '/applicant-form-bg.png';
